import { Box } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/besties/$siteId/revenue")({
  component: RevenuePage,
});

function RevenuePage() {
  return <Box sx={{ flex: 1, bgcolor: "common.white" }} />;
}
